import Loadable from '../../components/loadable';

const FailureFeeDescriptionModal = Loadable({
  loader: () => import('react/components/failure_fee_description_modal'),
  type: 'modal',
});

angular.module('gym').value('FailureFeeDescriptionModal', FailureFeeDescriptionModal);
